// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2kV6h","dragIcon":"SortableItem_dragIcon__2bVO8","disabled":"SortableItem_disabled__3bv8O"};